var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-days-solid",
    d: "M6,0A1.5,1.5,0,0,1,7.5,1.5V3h6V1.5a1.5,1.5,0,1,1,3,0V3h2.25A2.251,2.251,0,0,1,21,5.25V7.5H0V5.25A2.251,2.251,0,0,1,2.25,3H4.5V1.5A1.5,1.5,0,0,1,6,0ZM0,9H21V21.75A2.251,2.251,0,0,1,18.75,24H2.25A2.251,2.251,0,0,1,0,21.75Zm3,3.75v1.5a.752.752,0,0,0,.75.75h1.5A.752.752,0,0,0,6,14.25v-1.5A.752.752,0,0,0,5.25,12H3.75A.752.752,0,0,0,3,12.75Zm6,0v1.5a.752.752,0,0,0,.75.75h1.5a.752.752,0,0,0,.75-.75v-1.5a.752.752,0,0,0-.75-.75H9.75A.752.752,0,0,0,9,12.75ZM15.75,12a.752.752,0,0,0-.75.75v1.5a.752.752,0,0,0,.75.75h1.5a.752.752,0,0,0,.75-.75v-1.5a.752.752,0,0,0-.75-.75ZM3,18.75v1.5a.752.752,0,0,0,.75.75h1.5A.752.752,0,0,0,6,20.25v-1.5A.752.752,0,0,0,5.25,18H3.75A.752.752,0,0,0,3,18.75ZM9.75,18a.752.752,0,0,0-.75.75v1.5a.752.752,0,0,0,.75.75h1.5a.752.752,0,0,0,.75-.75v-1.5a.752.752,0,0,0-.75-.75Zm5.25.75v1.5a.752.752,0,0,0,.75.75h1.5a.752.752,0,0,0,.75-.75v-1.5a.752.752,0,0,0-.75-.75h-1.5A.752.752,0,0,0,15,18.75Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.739871a57c40493546540735af5d4015.svg";
export { ForwardRef as ReactComponent };